export class Constants {
    public readonly API: string = 'https://labs-ws.bigyellowfish.io/api';
}
